import React, {useMemo} from 'react';
import type {PartBool} from 'schemaDefinition/types';
import {useLocalization} from 'localization';
import {CheckboxField} from 'components';
import {useUniqueFieldId} from 'components/fields/hooks/useUniqueFieldId';
import {getBoxLabel} from 'schema/form/functions';
import type {BaseFieldProps} from './types';
import {useFormSchemaGlobalScopeContext} from '../../../contexts';

type Props = BaseFieldProps & {
  part: PartBool;
};

export const Checkbox: React.FC<Props> = ({
  part,
  value,
  setFieldValue,
  valuePath,
  label,
  mode,
  layout,
}) => {
  const localization = useLocalization();
  const {schema} = useFormSchemaGlobalScopeContext();
  const fieldId = useUniqueFieldId(valuePath);

  const boxLabel = useMemo(
    () => getBoxLabel(localization, part, schema),
    [localization, part, schema],
  );

  return (
    <CheckboxField
      fieldId={fieldId}
      name={valuePath}
      label={label ?? ''}
      boxLabel={boxLabel}
      layout={layout}
      readonly={mode === 'read-only'}
      value={!!value}
      onChange={newVal => setFieldValue(valuePath, newVal)}
    />
  );
};
